import type {
  SuperadminUserSuperadminPermissionResult,
  SuperadminUserSuperadminPermissionToEdit
} from 'api/models/mainservice';
import { protectedApiClient } from 'api/support/baseApiClients';

export default {
  getUsersPermissions: async (companyId: string) => {
    const result = await protectedApiClient.get<SuperadminUserSuperadminPermissionResult>(
      `/superadmin/company/${companyId}/superadminPermissions`
    );
    return result.data;
  },
  setUsersPermissions: async (params: {
    companyId: string;
    values: SuperadminUserSuperadminPermissionToEdit[];
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/superadmin/company/${params.companyId}/superadminPermissions/set`,
      params.values
    );
    return result.data;
  }
};
